if (!customElements.get('adev-new-blog')) {
    customElements.define('adev-new-blog', class adevNewBlog extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            const paginationWrap = this.querySelector('[data-adev-pagination="wrap"]');
            if (paginationWrap) {
                const itemsWrap = this.querySelector('[data-adev-infinite-scroll="html"]');
                if (itemsWrap) {
                    new InfiniteScroll( itemsWrap, {
                        path: '[data-adev-pagination="next"]',
                        append: '[data-adev-infinite-scroll="item"]',
                        history: false,
                        scrollThreshold: false,
                        button: '[data-adev-infinite-scroll="load-more"]',
                    });
                }
            }
        }

    });
}